export default function (store) {
  let result = {
    finish: null,
    cancel: null
  }
  let gotToken = false

  const user = store.getters['profile/currentUser']

  result.finish = new Promise((resolve, reject) => {
    const dialog = window.StripeCheckout.configure({
      key: store.getters['config/stripePublishableKey'],
      image: '',
      locale: 'auto',
      panelLabel: 'Save',
      token: async (token) => {
        gotToken = true
        await store.dispatch('payment/setPaymentToken', {token: token.id})
        resolve()
      },
      closed: () => {
        if (!gotToken) reject(new Error('no card'))
      }
    })

    dialog.open({
      name: 'Songback',
      description: user.stripe_customer_id ? 'Update credit card info' : 'Add credit card',
      email: user.email,
      zipCode: true,
      allowRememberMe: false
    })

    result.cancel = () => {
      dialog.close()
      reject(new Error('cancelled'))
    }
  })

  return result
}



// WEBPACK FOOTER //
// ./src/utils/stripe.js